import { useState } from "react";
import { Link } from "react-router-dom";
import GuideCard from "@/components/feature/GuideCard";
import { guides } from "@/mocks/guides";

const quickTags = ["新手补课", "打假鉴别", "热搜解读", "复盘写作"];

export default function GuideSection() {
  const [q, setQ] = useState("");
  const list = q.trim()
    ? guides.filter(
        (g) =>
          g.title.includes(q) ||
          g.subtitle.includes(q) ||
          g.excerpt.includes(q) ||
          g.tags.some((t) => t.includes(q))
      )
    : guides;

  return (
    <section id="zhinan" className="bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          {/* left intro / sticky */}
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-accent-700">
                <i className="ri-book-open-line" />
                How To Eat
              </p>
              <h2 className="mt-2 font-display text-2xl font-black text-foreground-950 md:text-4xl">
                吃瓜指南
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                不只告诉你「发生了什么」，更教你怎么看懂、怎么辨真假、怎么跟到大结局。零基础也能快速进圈。
              </p>

              <div className="mt-6 flex flex-wrap gap-2">
                {quickTags.map((t) => (
                  <button
                    key={t}
                    type="button"
                    onClick={() => setQ(t)}
                    className="rounded-md bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-accent-100 hover:text-accent-900 cursor-pointer"
                  >
                    #{t}
                  </button>
                ))}
              </div>

              <div className="mt-7 rounded-2xl border border-primary-200 bg-primary-50 p-5">
                <div className="flex items-center gap-2">
                  <i className="ri-lightbulb-flash-line text-xl text-primary-600" />
                  <h3 className="font-display text-base font-bold text-primary-900">新手专线</h3>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-primary-800">
                  第一次进圈很懵？先从「三分钟看懂时间线」开始，包你快速上道。
                </p>
                <Link
                  to="/zhinan/g1"
                  className="mt-3 inline-flex whitespace-nowrap items-center gap-1 text-sm font-semibold text-primary-700 hover:text-primary-800 cursor-pointer"
                >
                  新手必读第一课
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </div>

          {/* right list */}
          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <p className="text-sm text-foreground-500">
                <b className="text-accent-700">{list.length}</b> 篇指南供你补课
              </p>
              <label className="relative sm:w-72">
                <span className="sr-only">搜索吃瓜指南</span>
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-base text-foreground-400" />
                <input
                  type="search"
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                  placeholder="搜指南标题 / 方法…"
                  className="w-full rounded-md border border-background-300 bg-background-50 py-2 pl-9 pr-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-accent-400 focus:ring-2 focus:ring-accent-200"
                />
              </label>
            </div>

            {list.length ? (
              <div className="mt-6 space-y-4">
                {list.map((g) => (
                  <GuideCard key={g.id} guide={g} />
                ))}
              </div>
            ) : (
              <div className="mt-6 flex flex-col items-center rounded-2xl border border-dashed border-background-300 bg-background-50 px-6 py-12 text-center">
                <i className="ri-book-line text-4xl text-foreground-300" />
                <p className="mt-3 text-sm text-foreground-500">没有找到对应指南，换个方法关键词试试。</p>
                <button
                  type="button"
                  onClick={() => setQ("")}
                  className="mt-4 inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-accent-500 px-5 py-2 text-sm font-semibold text-background-50 hover:bg-accent-600 cursor-pointer"
                >
                  <i className="ri-refresh-line" />
                  查看全部
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}